import React, { useState, useEffect, ChangeEvent } from "react";
import { updateProfileApi } from "../api/updateuser";
import Cookies from "universal-cookie";

interface UpdateUserDetailsProps {
  usermodalopen: boolean;
  closeusermodal: () => void;
  url: string;
  isDarkMode: boolean;
  userdetails;
}

interface UserProfile {
  id: string;
  name: string | null;
  mobile: string | null;
  email: string;
  address: string | null;
  roleType: number;
}

const UpdateUserDetails: React.FC<UpdateUserDetailsProps> = ({
  usermodalopen,
  closeusermodal,
  url,
  isDarkMode,
  userdetails,
}) => {
  const [name, setName] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [user, setUser] = useState<UserProfile | null>(null);

  const cookies = new Cookies();
  const token = cookies.get("authToken");

  const userToken = token?.data?.token || token;
  // const dispatch = useDispatch();
  // console.log("in update", JSON.stringify(userdetails, null, 2));

  useEffect(() => {
    // const fetchUserProfile = async () => {
    // try {
    // const userProfile = await getProfileApi(userToken, url);
    if (userdetails) {
      setName(userdetails.name || "");
      setMobile(userdetails.mobile || "");
      setAddress(userdetails.address || "");
    }
  }, [usermodalopen, userToken, user]);

  const validateForm = () => {
    if (!name || !mobile || !address) {
      alert("Please fill in all required fields: Name, Mobile, and Address.");
      return false;
    }
    return true;
  };

  const handleUpdate = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!name.trim() || !mobile.trim() || !address.trim()) {
      alert("Name ,Mobile and Address fields cannot be empty.");
      return;
    }

    if (!validateForm()) return;
    try {
      const response = await updateProfileApi(
        url,
        userToken,
        name,
        mobile,
        address
      );
      if (response.status === 200) {
        alert("Updated Successfully");
        closeusermodal();
        window.location.reload();
      } else {
        console.error("Update failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleMobileChange = (event: ChangeEvent<HTMLInputElement>) => {
    setMobile(event.target.value);
  };

  const handleAddressChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAddress(event.target.value);
  };

  if (!usermodalopen) return null;

  return (
    <div
      onClick={closeusermodal}
      className={`fixed z-50 inset-0 flex items-center justify-center ${isDarkMode ? "bg-gray-800 bg-opacity-90" : "bg-gray-500 bg-opacity-75"
        }`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`rounded-lg p-6 w-full max-w-md relative ${isDarkMode
            ? "border border-gray-300 bg-[#242424] text-white"
            : "bg-white text-black"
          }`}
      >
        <button
          onClick={closeusermodal}
          className={`absolute top-3 right-3 ${isDarkMode
              ? "text-gray-300 hover:text-gray-500"
              : "text-gray-400 hover:text-gray-600"
            } text-3xl`}
        >
          &times;
        </button>

        <h3 className="text-center text-xl font-bold mb-4">
          Update User Details
        </h3>

        <div className="mb-4">
          <label
            className={`block text-sm font-medium mb-1 ${isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
          >
            Name
          </label>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={handleNameChange}
            className={`w-full p-2 border rounded focus:outline-none focus:ring ${isDarkMode
                ? "bg-gray-800 border-gray-700 text-white "
                : "border-gray-300 "
              }`}
          />
        </div>

        <div className="mb-4">
          <label
            className={`block text-sm font-medium mb-1 ${isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
          >
            Mobile
          </label>
          <input
            type="tel"
            placeholder="Mobile"
            value={mobile}
            onChange={handleMobileChange}
            className={`w-full p-2 border rounded focus:outline-none focus:ring ${isDarkMode
                ? "bg-gray-800 border-gray-700 text-white "
                : "border-gray-300 "
              }`}
          />
        </div>

        <div className="mb-4">
          <label
            className={`block text-sm font-medium mb-1 ${isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
          >
            Address
          </label>
          <input
            type="text"
            placeholder=" Provide Your Address Here"
            value={address}
            onChange={handleAddressChange}
            className={`w-full p-2 border rounded focus:outline-none focus:ring ${address?.trim() === "" ? "border-red-500" : ""
              } ${isDarkMode
                ? "bg-gray-800 " + (address?.trim() === "" ? "" : "border-gray-700 text-white")
                : address?.trim() === "" ? "" : "border-gray-300"
              }`}
          />
        </div>

        <div className="flex justify-end">
          <button
            onClick={handleUpdate}
            className={`px-4 py-2 rounded ${isDarkMode
                ? "bg-blue-500 hover:bg-blue-400 text-white"
                : "bg-blue-500 hover:bg-blue-400 text-white"
              }`}
          >
            Update Details
          </button>
        </div>
      </div>
    </div>
  );
};
export default UpdateUserDetails;
